import React from 'react';
import './WhatThisIs.css';

export default function WhatThisIs() {
  return (
    <section className="what-this-is landing__section" aria-labelledby="what-heading">
      <div className="landing__column landing__column--narrow">
        <div className="fade-up">
          <h2 className="what-this-is__heading" id="what-heading">
            What you actually open.
          </h2>
          <p className="what-this-is__body">
            You open it on a Tuesday morning and it asks a quiet question —
            drawn from a goal you wrote down three weeks ago. You answer,
            log a task, check the life wheel, remember that one value you
            keep meaning to act on.
          </p>
          <p className="what-this-is__body what-this-is__body--emphasis">
            Five minutes. Nothing leaves your device. You close it and know
            exactly what you're working on and why.
          </p>
        </div>
      </div>
    </section>
  );
}
